import redirect, { getQueryParamsFromUrl } from '../../utils/redirect';
import useAdyen, { AdyenConfig, CardConfig } from '../../utils/useAdyen';

// https://docs.adyen.com/payment-methods/paypal/web-component
const AdyenPaypalPayment = () => {
  const adyenConfig: AdyenConfig = {
    payButton: 'adyen', // Paypal does not allow to submit from custom button
    withButtonActionsRef: true,
    onAdditionalDetails: (params, callbackUrlRef) => {
      const parametersFromUrl = getQueryParamsFromUrl(callbackUrlRef.current!);
      const parameters = [
        { name: 'details', value: JSON.stringify(params.data.details) },
        { name: 'paymentData', value: params.data.paymentData! },
        { name: 'referer', value: 'internal' },
        ...parametersFromUrl
      ];
      redirect({ method: 'GET', url: callbackUrlRef.current!.split('?')[0], parameters });
    }
  };

  const cardConfig: CardConfig = {
    // intent,
    blockPayPalCreditButton: true,
    blockPayPalPayLaterButton: true
  };

  const AdyenPaypalComponent = useAdyen({
    name: 'paypal',
    adyenConfig,
    cardConfig,
    withActions: true
  });

  return <div style={{ minWidth: '170px' }}>{AdyenPaypalComponent}</div>;
};

export default AdyenPaypalPayment;
